var _path, _path2, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoupon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0374 9.72985C27.2907 8.37879 30.2025 9.66606 30.7198 12.242C31.0088 13.681 32.1003 14.8251 33.524 15.1815C36.0727 15.8195 37.2215 18.7887 35.7658 20.9759C34.9526 22.1978 34.9154 23.7786 35.6701 25.0374C37.0212 27.2907 35.7339 30.2025 33.158 30.7198C31.719 31.0088 30.5749 32.1003 30.2185 33.5241C29.5805 36.0728 26.6113 37.2215 24.424 35.7658C23.2022 34.9527 21.6214 34.9154 20.3626 35.6702C18.1093 37.0212 15.1974 35.7339 14.6802 33.158C14.3912 31.719 13.2997 30.5749 11.8759 30.2185C9.32724 29.5805 8.17851 26.6113 9.63417 24.4241C10.4473 23.2022 10.4846 21.6214 9.72984 20.3626C8.37879 18.1093 9.66606 15.1975 12.242 14.6802C13.6809 14.3912 14.8251 13.2997 15.1815 11.8759C15.8195 9.32725 18.7887 8.17852 20.9759 9.63417C22.1978 10.4473 23.7786 10.4846 25.0374 9.72985Z",
    fill: "#2D81F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8641 18.0303L17.6196 29.0943",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.2587,
    cy: 19.2596,
    r: 1.22934,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.6347,
    cy: 26.6356,
    r: 1.22934,
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupon);
export default __webpack_public_path__ + "static/media/coupon.ce246656748e284fc77bbf496b5d12d7.svg";
export { ForwardRef as ReactComponent };